module.exports = {
    collectionZone: 'Collection Zone'
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/trolley-source.js
 **/